module.exports = __webpack_public_path__ + "img/slide-2.0d915b02.png";